module.exports = __webpack_public_path__ + "static/img/ljj.4812ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/ljj.png
// module id = kBK+
// module chunks = 1